import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormOctagon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-octagon"><path d="M15.8315 2.75L21.25 8.16852V15.8315L15.8315 21.25H8.16852L2.75 15.8315L2.75 8.16852L8.16852 2.75L15.8315 2.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFormOctagon;
